import Img1 from "../../images/GalleryPage/Gallery1.jpg";
import Img2 from "../../images/GalleryPage/Gallery2.jpg";
import Img3 from "../../images/gallery/workspace 1 .jpg";
import Img4 from "../../images/gallery/workplace 2.jpg";
import Img5 from "../../images/gallery/workplace 3.jpg";
import Img6 from "../../images/gallery/workplace 4.jpg";


export const galleryImg = [
  {
    img: Img1,
    id: 1,
  },
  {
    img: Img2,
    id: 2,
  },
  {
    img: Img3,
    id: 3,
  },
  {
    img: Img4,
    id: 4,
  },
  {
    img: Img5,
    id: 5,
  },
  {
    img: Img6,
    id: 6,
  },
  
];
